export default {
  confirmarConta: {
    aguarde: "Espera, estamos creando tu cuenta...",
    falhaAoCarregarDados: "Error al crear cuenta",
    confirmacao:
      "Su cuenta está lista. Recibirás un correo electrónico para crear tu contraseña"
  }
};
